"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconButton = exports.StyledControlIcons = exports.StyledCollapseAll = exports.StyledBodyItem = exports.StyledBody = exports.StyledHeader = void 0;
const ui_components_1 = require("@groupby/ui-components");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledHeader = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0.25rem 0.5rem;

  border: 1px solid ${ui_components_1.baseColors.border};

  color: ${({ theme }) => theme.palette.accent.main};
  font-size: ${({ theme }) => theme.spacing(2.25)};
`;
exports.StyledBody = styled_components_1.default.ul `
  margin: 0;
  padding: 0.25rem 0;

  background-color: ${ui_components_1.baseColors.background050};
  border-top: 1px solid ${ui_components_1.baseColors.background100};
`;
exports.StyledBodyItem = styled_components_1.default.li `
  padding: 0.75rem 0.63rem;
  font-size: 0.75rem;
`;
exports.StyledCollapseAll = styled_components_1.default.div `
  text-transform: uppercase;

  color: ${ui_components_1.baseColors.primaryGreen100};
  font-size: 0.63rem;

  cursor: pointer;

  &:hover {
    color: ${ui_components_1.baseColors.primaryGreen000};
  }
`;
exports.StyledControlIcons = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
exports.StyledIconButton = (0, styled_components_1.default)(IconButton_1.default) `
  color: transparent;
`;
